import { render, staticRenderFns } from "./exchange-order-list.vue?vue&type=template&id=6ea5d2b5&scoped=true&"
import script from "./exchange-order-list.vue?vue&type=script&lang=js&"
export * from "./exchange-order-list.vue?vue&type=script&lang=js&"
import style0 from "./exchange-order-list.vue?vue&type=style&index=0&id=6ea5d2b5&prod&lang=scss&"
import style1 from "./exchange-order-list.vue?vue&type=style&index=1&id=6ea5d2b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea5d2b5",
  null
  
)

export default component.exports